import React from 'react'
import './vendor-count.scss'

export default function( props ){
  return <span className="vendor-count">{ props.count }</span>
}
